export default __webpack_public_path__ + "static/media/healthcare.d424dcbf.webp";